//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.2.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface MieResendMedComMessageDto {
    id: string;
    receiverSorLocationCode?: string | undefined;
    receiverSorId?: string | undefined;
}

export interface MiePageOfMieMedComMessageDto {
    items: MieMedComMessageDto[];
    skipped: number;
    totalCount: number;
}

export interface MieMedComMessageDto {
    id: string;
    messageType: MieMedComMessageType;
    originalMedComMessageId?: string | undefined;
    vansEnvelopeIdentifier: string;
    vansMessageIdentifier: string;
    letterIdentifier: string;
    envelopeIdentifier: string;
    receiverEANIdentifier: string;
    receiverIdentifier: string;
    senderEANIdentifier: string;
    senderIdentifier: string;
    medComMessageStatuses?: MieXdisMedComMessageStatusDto[] | undefined;
    createdAt: Date;
    xdis02MedComMessage?: MieXdis02MedComMessageDto | undefined;
    dermloopUrl?: string | undefined;
}

export enum MieMedComMessageType {
    Xdis02 = "Xdis02",
    Xdis91 = "Xdis91",
    Xbin01 = "Xbin01",
}

export interface MieXdisMedComMessageStatusDto {
    id: string;
    messageStatus: MieMessageStatus;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    data?: string | undefined;
    createdAt: Date;
    receiptSentDate?: Date | undefined;
}

export enum MieMessageStatus {
    Error = "Error",
    Created = "Created",
    Sent = "Sent",
    VansPositiveAcknowledged = "VansPositiveAcknowledged",
    VansNegativeAcknowledged = "VansNegativeAcknowledged",
    VansRejected = "VansRejected",
    XctlPositiveAcknowledged = "XctlPositiveAcknowledged",
    XctlNegativeAcknowledged = "XctlNegativeAcknowledged",
    XctlRejected = "XctlRejected",
    XmlValidationError = "XmlValidationError",
    DtoValidationError = "DtoValidationError",
    ErrorManuallyResolved = "ErrorManuallyResolved",
    DtoCreationError = "DtoCreationError",
}

export interface MieXdis02MedComMessageDto {
    xdis02ActionPriorityCode?: MieXdis02ActionPriorityCode | undefined;
}

export enum MieXdis02ActionPriorityCode {
    Rutine = "Rutine",
    Subakut = "Subakut",
    Akut = "Akut",
}

export interface MieSearchMedComMessages {
    statuses?: MieMessageStatus[] | undefined;
    createdAfterIso?: string | undefined;
    createdBeforeIso?: string | undefined;
    take: number;
    skip: number;
}

export interface MiePatchMedComMessageStatusDto {
    status: MieMessageStatus;
    data?: string | undefined;
}

export interface MieNspAuditActivityResponseDto {
    success: boolean;
    metadata: MieNspAuditActivityResponseMetadataDto;
}

export interface MieNspAuditActivityResponseMetadataDto {
    consentPassed?: boolean | undefined;
    brsCheckPassed?: boolean | undefined;
    consentEvaluated?: boolean | undefined;
    brsRelations?: string | undefined;
    brsRelationsBySource?: string | undefined;
}

export interface MieNspAuditActivityRequestDto {
    userInfo: MieNspAuditUserInfoDto;
    patientCpr: string;
    patientName?: string | undefined;
    patientAction: MieNspAuditPatientAction;
    medicalUnitSorProviderId?: string | undefined;
    medicalUnitSorId?: string | undefined;
    brsCheckDisabled?: boolean | undefined;
}

export interface MieNspAuditUserInfoDto {
    employeeCpr: string;
    bootstrapToken?: string | undefined;
    authorizationCode?: string | undefined;
    onBehalfOf?: MieNspAuditOnBehalfOfDto | undefined;
}

export interface MieNspAuditOnBehalfOfDto {
    cpr: string;
    authorizationCode: string;
}

export enum MieNspAuditPatientAction {
    Create = "Create",
    Read = "Read",
    Update = "Update",
    Delete = "Delete",
    Unknown = "Unknown",
}

export interface MieNspAuthorizationResponseDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    isOk?: boolean | undefined;
    message?: string | undefined;
    authorizations?: MieNspAuthorizationResponseAuthorizationDto[] | undefined;
}

export interface MieNspAuthorizationResponseAuthorizationDto {
    authorizationCode?: string | undefined;
    educationCode?: string | undefined;
    educationName?: string | undefined;
}

export interface MieNspAuthorizationRequestDto {
    userCpr: string;
}

export interface MiePatchHl7MessageStatusDto {
    status: MieHl7MessageStatus;
}

export enum MieHl7MessageStatus {
    Error = "Error",
    Created = "Created",
    SentToMirth = "SentToMirth",
    MirthDelivered = "MirthDelivered",
    MirthDeliveryFailed = "MirthDeliveryFailed",
    MirthAcknowledged = "MirthAcknowledged",
    Hl7NegativeAcknowledged = "Hl7NegativeAcknowledged",
    Hl7ValidationError = "Hl7ValidationError",
    DtoValidationError = "DtoValidationError",
    DtoCreationError = "DtoCreationError",
    MirthConnectionError = "MirthConnectionError",
    ErrorManuallyResolved = "ErrorManuallyResolved",
    Queued = "Queued",
}

export interface MieHl7GenerateResponseDto {
    success: boolean;
    errors: string[];
    messages?: MieHl7MessagesDto | undefined;
}

export interface MieHl7MessagesDto {
    oruMessage?: MieHl7GeneratedMessageDto | undefined;
    dftMessage?: MieHl7GeneratedMessageDto | undefined;
}

export interface MieHl7GeneratedMessageDto {
    messageType: string;
    messageControlId: string;
    hl7Version: string;
    generatedAt: Date;
    rawMessage: string;
    messageLength: number;
}

export interface MieHl7GenerateRequestDto {
    messagesToGenerate: MieHl7MessageTypesToGenerate;
    patient: MieHl7PatientDto;
    encounter: MieHl7EncounterDto;
    assessment: MieHl7AssessmentDto;
    provider: MieHl7ProviderDto;
    order?: MieHl7OrderDto | undefined;
    billing?: MieHl7BillingDto | undefined;
    facility: MieHl7FacilityDto;
}

export interface MieHl7MessageTypesToGenerate {
    generateOru: boolean;
    generateDft: boolean;
}

export interface MieHl7PatientDto {
    medicalRecordNumber: string;
    assigningAuthority: string;
    lastName: string;
    firstName: string;
    dateOfBirth: Date;
    sex: Hl7PatientSex;
}

export enum Hl7PatientSex {
    Male = "Male",
    Female = "Female",
    Other = "Other",
    Unknown = "Unknown",
}

export interface MieHl7EncounterDto {
    encounterId: string;
    patientClass: Hl7PatientClass;
    department?: string | undefined;
    room?: string | undefined;
    bed?: string | undefined;
    patientLocationFacility?: string | undefined;
    admitDateTime?: Date | undefined;
}

export enum Hl7PatientClass {
    Outpatient = "Outpatient",
    Inpatient = "Inpatient",
    Emergency = "Emergency",
    Preadmit = "Preadmit",
}

export interface MieHl7AssessmentDto {
    assessmentId: string;
    assessmentDateTime: Date;
    referralId: string;
    referralDateTime: Date;
    clinicalFindings: MieHl7ClinicalFindingDto[];
    documentData: string;
    images?: MieHl7ImageDto[];
    expectedImageCount?: number | undefined;
    priority?: Hl7Priority | undefined;
}

export interface MieHl7ClinicalFindingDto {
    sequenceNumber: number;
    findingType: Hl7ClinicalFindingType;
    diagnosisCode?: string | undefined;
    text: string;
    codingSystem?: DiagnosisCodingSystem | undefined;
    observationDateTime?: Date | undefined;
    comment?: string | undefined;
    isPrimary: boolean;
}

export enum Hl7ClinicalFindingType {
    PrimaryDiagnosis = "PrimaryDiagnosis",
    DifferentialDiagnosis = "DifferentialDiagnosis",
    Observation = "Observation",
    ClinicalNote = "ClinicalNote",
}

export enum DiagnosisCodingSystem {
    Icd10 = "Icd10",
    Loinc = "Loinc",
    Local = "Local",
    Gdt = "Gdt",
}

export interface MieHl7ImageDto {
    downloadUrl: string;
    imageType: Hl7ImageType;
    isFlash?: boolean | undefined;
    observationDateTime: Date;
}

export enum Hl7ImageType {
    Overview = "Overview",
    Clinical = "Clinical",
    CloseUp = "CloseUp",
    Dermoscopic = "Dermoscopic",
}

export enum Hl7Priority {
    Routine = "Routine",
    SubAcute = "SubAcute",
    Acute = "Acute",
}

export interface MieHl7ProviderDto {
    performingProviderId: string;
    performingProviderNpi: string;
    performingProviderLastName: string;
    performingProviderFirstName: string;
    orderingProviderLastName?: string | undefined;
    orderingProviderFirstName?: string | undefined;
    orderingProviderNpi?: string | undefined;
}

export interface MieHl7OrderDto {
    orderId: string;
}

export interface MieHl7BillingDto {
    transactionId: string;
    transactionDate: Date;
    postedDate?: Date | undefined;
    cptCode: string;
    cptDescription: string;
    notes?: string[] | undefined;
}

export interface MieHl7FacilityDto {
    sendingFacility: string;
    receivingApplication: string;
    receivingFacility: string;
}

export interface MiePageOfMieHl7SendRequestDto {
    items: MieHl7SendRequestDto[];
    skipped: number;
    totalCount: number;
}

export interface MieHl7SendRequestDto {
    id: string;
    encounterId?: string | undefined;
    patientId?: string | undefined;
    orderId?: string | undefined;
    sendingFacility: string;
    sendingApplication: string;
    receivingFacility: string;
    receivingApplication: string;
    createdAt: Date;
    hl7Messages: MieHl7MessageDto[];
    latestStatusesByType: MieHl7LatestStatusByTypeDto[];
    teleAssessmentId?: string | undefined;
}

export interface MieHl7MessageDto {
    id: string;
    messageType: MieHl7MessageType;
    originalHl7MessageId?: string | undefined;
    messageControlId: string;
    mirthChannelId?: string | undefined;
    mirthMessageId?: string | undefined;
    sendingFacility: string;
    sendingApplication: string;
    receivingFacility: string;
    receivingApplication: string;
    patientId?: string | undefined;
    hl7MessageStatuses?: MieHl7MessageStatusDto[] | undefined;
    createdAt: Date;
    oruHl7Message?: MieOruHl7MessageDto | undefined;
    dftHl7Message?: MieDftHl7MessageDto | undefined;
}

export enum MieHl7MessageType {
    OruR01 = "OruR01",
    DftP03 = "DftP03",
}

export interface MieHl7MessageStatusDto {
    id: string;
    messageStatus: MieHl7MessageStatus;
    statusDate?: Date | undefined;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    data?: string | undefined;
    createdAt: Date;
    mirthConnectorMessageId?: string | undefined;
    sendAttempts?: number | undefined;
}

export interface MieOruHl7MessageDto {
    encounterId?: string | undefined;
    orderControlCode?: string | undefined;
    observationIdentifier?: string | undefined;
}

export interface MieDftHl7MessageDto {
    encounterId?: string | undefined;
    transactionId?: string | undefined;
    transactionType?: string | undefined;
    transactionAmount?: number | undefined;
}

export interface MieHl7LatestStatusByTypeDto {
    messageType: MieHl7MessageType;
    status: MieHl7MessageStatus;
    errorMessage?: string | undefined;
    sendAttempts?: number | undefined;
}

export interface MieSearchHl7SendRequests {
    statuses?: MieHl7MessageStatus[] | undefined;
    createdAfterIso?: string | undefined;
    createdBeforeIso?: string | undefined;
    take: number;
    skip: number;
}

export interface MieResendHl7SendRequestDto {
    resendOru: boolean;
    resendDft: boolean;
    documentData?: string | undefined;
    images?: MieHl7ImageDto[] | undefined;
    expectedImageCount?: number | undefined;
    generateRequest?: MieHl7GenerateRequestDto | undefined;
}

export interface MieDtoCreationFailureDto {
    messageType: MieMedComMessageType;
    errorMessage: string;
    additionalContext: { [key: string]: any; };
    sender?: MieXdisSenderDto | undefined;
    receiver?: MieXdisReceiverDto | undefined;
    originalMedComMessageId?: string | undefined;
}

export interface MieXdisSenderDto {
    sorLocationCode: string;
    organisationName: string;
}

export interface MieXdisReceiverDto {
    sorLocationCode: string;
    sorId: string;
}

export interface MieSendXdis02MessageDto {
    originalMedComMessageId?: string | undefined;
    sender: MieXdisSenderDto;
    receiver: MieXdisReceiverDto;
    patient: MieXdisPatientDto;
    referral: MieXdis02ReferralDto;
    xdis02ActionPriorityCode?: MieXdis02ActionPriorityCode | undefined;
    diagnoseMain?: MieXdisDiagnosisDto | undefined;
    diagnoseMainAdditionals?: MieXdisDiagnosisDto[] | undefined;
    recommendationText?: string | undefined;
    clinicalInformationText?: string | undefined;
    dermloopUrl: string;
}

export interface MieXdisPatientDto {
    civilRegistrationNumber: string;
    personSurnameName: string;
    personGivenName: string;
}

export interface MieXdis02ReferralDto {
    receivedUtcDate: Date;
    refer?: MieXdisDiagnosisDto | undefined;
    referralAdditional?: MieXdisDiagnosisDto | undefined;
}

export interface MieXdisDiagnosisDto {
    diagnoseSksCode: string;
    diagnoseSksName: string;
}

export interface MieSendXdis91MessageDto {
    originalMedComMessageId?: string | undefined;
    sender: MieXdisSenderDto;
    receiver: MieXdisReceiverDto;
    patient: MieXdisPatientDto;
    title: string;
    clinicalInformationText: string;
    dermloopUrl: string;
}

export interface MieHl7DtoCreationFailureDto {
    errorMessage: string;
    additionalContext: { [key: string]: any; };
    teleAssessmentId?: string | undefined;
    messagesToGenerate?: MieHl7MessageTypesToGenerate | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}